<template>
    <div>
        <transition name="fade">
            <div
                v-show="isExpanded"
                class="background-darken"
                @click.stop="isExpanded = false" />
        </transition>
        <div
            class="mobile-footer box"
            :class="{'expanded': isExpanded}">
            <div
                class="stay-top-row d-flex align-items-center pointer"
                @click="isExpanded = !isExpanded">
                <AnbieterLogo class="logo-mobile" />
                <div class="ml-2 flex-grow-1 d-flex flex-column min-width-0">
                    <h4 v-if="siteData">
                        <font-awesome-icon
                            v-if="siteData.internal"
                            class="mr-2"
                            icon="lock" />
                        {{ siteData.title }}
                    </h4>
                </div>

                <font-awesome-icon
                    fixed-width
                    icon="folder-open" />
                <EmployeeHint small />
                <BookingCart small />
                <font-awesome-icon
                    icon="chevron-up"
                    class="chevron ml-2" />
            </div>
            <div class="invoice-row flex-grow-1 h-100 d-flex">
                <div
                    class="overflow-auto flex-grow-1"
                    style="max-height: 100%;">
                    <transition name="fade-invoice">
                        <div v-show="isExpanded">
                            <DocumentList
                                v-if="siteData?.documents?.length"
                                style="font-size: 14px" />
                            <BookingList />
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AnbieterLogo from "@/components/layouts/onlineBooking/AnbieterLogo";
import mainSiteMixin from "@/mixins/mainSiteMixin";
import BookingCart from "@/components/layouts/onlineBooking/BookingCart";
import BookingList from "@/components/farbcode-core/BookingList";
import EmployeeHint from '@/components/layouts/onlineBooking/EmployeeHint'

export default {
    name: "MobileFooter",
    components: {EmployeeHint, BookingList, BookingCart, AnbieterLogo},
    mixins: [mainSiteMixin],
    data() {
        return {
            isExpanded: false
        }
    }
}
</script>

<style lang="scss" scoped>
@use "sass:map";

.box {
    box-shadow: $box-shadow;
    background: $white;
}

.mobile-footer {
    position: fixed;
    overflow: hidden;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1;
    height: $registration-mobile-footer-height-closed;
    transition: height $registration-transition-duration $registration-timing-function-half;

    .stay-top-row {
        height: $registration-mobile-footer-height-closed;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0 map.get($spacers, 3) 0 map.get($spacers, 2);
        z-index: 3;

        .chevron {
            transition: transform $registration-transition-duration $registration-timing-function;
        }
    }

    .invoice-row {
        padding-top: calc(#{$registration-mobile-footer-height-closed} + #{map.get($spacers, 2)});
        padding-bottom: $registration-mobile-footer-stay-bottom-height;
        margin-right: map.get($spacers, 2);
        margin-left: map.get($spacers, 2);

        .fade-invoice-enter-active {
            transition: opacity .5s ease .2s;
        }

        .fade-invoice-leave-active {
            transition: opacity .3s;
        }

        .fade-invoice-enter, .fade-invoice-leave-to {
            opacity: 0;
        }
    }
}

.mobile-footer.expanded {
    height: $registration-mobile-footer-max-height-expanded;

    .stay-top-row {
        .chevron {
            transform: rotate(180deg);
        }
    }
}

.background-darken {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: $black;
    opacity: 0.5;
    z-index: 1;
}


.logo-mobile {
    height: calc(#{$registration-mobile-footer-height-closed} - 2 * #{map.get($spacers, 2)});
    max-width: 70px;
    min-width: calc(#{$registration-mobile-footer-height-closed} - 2 * #{map.get($spacers, 2)});
    margin: map.get($spacers, 2) 0;
}

.fade-enter-active, .fade-leave-active {
    transition: opacity $registration-transition-duration $registration-timing-function;
}

.fade-enter, .fade-leave-to {
    opacity: 0 !important;
}

</style>
